"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.isHiylloIcon = exports.createHiylloIcon = void 0;
var react_1 = __importDefault(require("react"));
function createHiylloIcon(component) {
    var c = react_1["default"].memo(component);
    c.__brand = "HiylloIcon";
    return c;
}
exports.createHiylloIcon = createHiylloIcon;
;
function isHiylloIcon(h) {
    return h && typeof h === 'object' && '__brand' in h && h.__brand === "HiylloIcon";
}
exports.isHiylloIcon = isHiylloIcon;
